import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import i18n from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getErrorMessageFromAPI } from '../../../utilz';
import { setAppLoader } from '../../common/CommonActions';
import {
  getProcurementAddLaneInformationInFail,
  getProcurementAddLaneInformationInSuccess,
  getProcurementHistoricalBidListInFail,
  getProcurementHistoricalBidListInSuccess,
  getProcurementLaneInformationInFail,
  getProcurementLaneInformationInSuccess,
  getProcurementTenderListInFail,
  getProcurementTenderListInSuccess,
  getTenderCarrierListInFail,
  getTenderCarrierListInSuccess,
  getTenderCopyInFail,
  getTenderCopyInSuccess,
} from './ProcurementTenderAction';
import {
  getAddLaneInformationEffect,
  getHistoricalBidListEffect,
  getLaneInformationEffect,
  getTenderCopyEffect,
  getTenderListEffect,
  getTransportProviderEffect,
  updateTenderEffect,
} from './ProcurementTenderEffects';
import ProcurementTenderType from './ProcurementTenderType';

export const procurementTender = (state) => state.procurementTender;

function removeEmptyObjects(obj) {
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'object') {
      removeEmptyObjects(obj[key]);
    } else if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
}

function* getTenderListAction() {
  try {
    const { tenderList } = yield select(procurementTender);
    const requetParams = yield call(removeEmptyObjects, tenderList.req);
    const { data } = yield call(getTenderListEffect, requetParams);
    yield put(getProcurementTenderListInSuccess({ data: data }));
  } catch (e) {
    yield put(getProcurementTenderListInFail({ message: getErrorMessageFromAPI(e) }));
  }
}

function* updateTenderAction({ payload }) {
  yield put(setAppLoader(true));
  try {
    const { data } = yield call(updateTenderEffect, payload);
    if (!data?.success) {
      yield call(showNotification, {
        type: NOTIFICATION_TYPES.ERROR,
        message: data?.tenderModeMessage || 'Update error',
      });
    }
    yield put(setAppLoader(false));
  } catch (e) {
    const errMsg = getErrorMessageFromAPI(e, 'Update Tender Error');
    yield call(showNotification, {
      type: NOTIFICATION_TYPES.ERROR,
      message: errMsg,
    });
    yield put(setAppLoader(false));
  }
}

function* TenderCopyAction() {
  try {
    const { tenderCopy } = yield select(procurementTender);

    const requetParams = yield call(removeEmptyObjects, tenderCopy.req);

    const { data } = yield call(getTenderCopyEffect, requetParams);
    if (data === 'Error') {
      throw i18n.t('translation:default.notification.copyTenderError');
    }
    yield call(showNotification, {
      type: NOTIFICATION_TYPES.SUCCESS,
      message: i18n.t('translation:default.notification.copyTender'),
    });
    yield put(getTenderCopyInSuccess({ data: data }));
  } catch (e) {
    const errMsg = getErrorMessageFromAPI(e, i18n.t('translation:default.notification.copyTenderError'));
    yield call(showNotification, {
      type: NOTIFICATION_TYPES.ERROR,
      message: errMsg,
    });
    yield put(getTenderCopyInFail({ message: errMsg }));
  }
}

function* getLaneInformationAction(payload) {
  try {
    const { data } = yield call(getLaneInformationEffect, payload?.payload);
    yield put(getProcurementLaneInformationInSuccess({ data }));
  } catch (e) {
    yield put(
      getProcurementLaneInformationInFail({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* getAddLaneInformationAction(payload) {
  try {
    const { data } = yield call(getAddLaneInformationEffect, payload?.payload);

    yield put(getProcurementAddLaneInformationInSuccess({ data: data }));
  } catch (e) {
    yield put(
      getProcurementAddLaneInformationInFail({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* getTransportProviderAction(payload) {
  try {
    const { data } = yield call(getTransportProviderEffect, payload?.payload);
    yield put(getTenderCarrierListInSuccess({ data: data }));
  } catch (e) {
    yield put(
      getTenderCarrierListInFail({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* getHistoricalBidListAction(payload) {
  try {
    const { data } = yield call(getHistoricalBidListEffect, payload?.payload);
    yield put(getProcurementHistoricalBidListInSuccess({ data: data }));
  } catch (e) {
    yield put(
      getProcurementHistoricalBidListInFail({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

export default function* procurementTenderSaga() {
  yield takeLatest(ProcurementTenderType.GET_PROCUREMENT_TENDER_LIST, getTenderListAction);
  yield takeLatest(ProcurementTenderType.CREATE_TENDER_COPY, TenderCopyAction);
  yield takeLatest(ProcurementTenderType.UPDATE_TENDER_PROGRESS, updateTenderAction);

  yield takeLatest(ProcurementTenderType.GET_PROCUREMENT_LANE_INFORMATION, getLaneInformationAction);

  yield takeLatest(ProcurementTenderType.GET_PROCUREMENT_ADD_LANE_INFORMATION, getAddLaneInformationAction);

  yield takeLatest(ProcurementTenderType.GET_TENDER_CARRIER_LIST, getTransportProviderAction);

  yield takeLatest(ProcurementTenderType.GET_PROCUREMENT_HISTORICAL_BID_LIST, getHistoricalBidListAction);
}
